import { useEffect, useState } from 'react';

const DEFAULT_TICK_MS = 60 * 1000;

/**
 * Returns the current epoch ms, refreshed on a periodic timer so consumers
 * re-render as resource-request retention thresholds (6h timeout, 24h queue
 * expiry) cross. One-minute precision is plenty for hour-scale thresholds.
 */
export function useResourceRequestClock(
  tickMs: number = DEFAULT_TICK_MS,
): number {
  const [nowMs, setNowMs] = useState<number>(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNowMs(Date.now()), tickMs);
    return () => window.clearInterval(id);
  }, [tickMs]);

  return nowMs;
}
